import React from "react";

import async from "_components/Async";
import { NavLink } from "react-router-dom";
import {
  Users,
  Sliders,
} from "react-feather";
import Page404 from "_pages/common/Page404";
import Page500 from "_pages/common/Page500";
import PageNoOrg from "_pages/common/PageNoOrg";
import Overview from "_pages/subscriptions/Overview";
import GenCode from "_pages/auth/GenCode";
import ConfirmCode from "_pages/auth/ConfirmCode";
import AuthGuard from "_components/AuthGuard"
import PageSupport from "_pages/common/PageSupport";

// Code generation page
const defaultRoutes = {
  id: "Default",
  path: "/",
  header: "Pages",
  icon: <Sliders />,
  containsHome: true,
  children: [
    {
      path: "/auth/:organizationSlug/verify",
      name: "GenCode",
      component: GenCode,
    },
    {
      path: "/auth/:organizationSlug/confirm",
      name: "ConfirmCode",
      component: ConfirmCode,
    },
    {
      path: "/404",
      name: "404 Page",
      component: Page404,
    },
    {
      path: "/500",
      name: "500 Page",
      component: Page500,
    },
    {
      path: "/error",
      name: "Error Page",
      component: PageNoOrg
    },
    {
      path: "/support",
      name: "Support Page",
      component: PageSupport,
      guard: AuthGuard,
    }
  ],
  component: null,
};
// Routes using the Default layout
export const defaultLayoutRoutes = [defaultRoutes];

const subscriptionRoutes = {
  path: "/overview/:organizationSlug",
  name: "Overview",
  component: Overview,
  guard: AuthGuard,
};

export const subLayoutRoutes = [subscriptionRoutes];